export default __webpack_public_path__ + "static/media/comprehension_locked_crown.236c8709.svg";